import { useDispatch } from 'react-redux'
import { InputSwitch } from 'primereact/inputswitch'
import { useAppSelector } from '../../../../../stateManagement/hooks/redux'
import { setMapRankingIsEnabled } from '../../../../../stateManagement/reducers'

export default function MapRankingSwitcher() {
    const dispatch = useDispatch()

    const mapRankingIsEnabled = useAppSelector(state => state.contentHeader.mapRankingIsEnabled)

    function switchMapRanking(value) {
        dispatch(setMapRankingIsEnabled(value))
    }

    return (
        <div className='map-ranking-switcher-div'>
            <label htmlFor="rankingFlag">Ранжирование</label>
            <InputSwitch checked={mapRankingIsEnabled} inputId="rankingFlag" onChange={(e) => switchMapRanking(e.value)} />
        </div>
    )
}
